
import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import callAPI from "../../comps/fetch/main";
import ShowPlans from "../../comps/show_plans/main";
import { Alert,Progress, Radio, Input, Skeleton, Carousel,List, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Select, FloatButton, Flex, Form ,Steps, Checkbox,Rate} from "antd";
import { RightCircleOutlined, VideoCameraOutlined, HistoryOutlined, PlusSquareOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined, BranchesOutlined, FilterOutlined, FilterTwoTone, InstagramOutlined, YoutubeOutlined, CommentOutlined, MessageOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
import AccessOrNot from "../../funcs/accessOrNot";
import AutomationList from "../automationList/main";
import WhatsNew from "../../comps/whatsNew/main";
import IGPosts from "../../comps/list-ig-posts/main";
import HomeDashboard from "../../comps/home-dashboard/main";
import confetti from "canvas-confetti";
import { fireDB } from "../../funcs/firebase";
import { getDocs , collection,doc, getDoc, setDoc,deleteDoc,serverTimestamp } from "firebase/firestore";

const { Step } = Steps;
function WelcomePopup({PlanData}) {
  const [open, setOpen] = useState();
  const [current, setCurrent] = useState(0);
  const[userData, setUserData] = useState(JSON.parse(localStorage.getItem("userData")))
  const [form] = Form.useForm();
  const[thankYou, setThankYou] = useState(false)



  let survery_collection = "survey-nov-10-2025" //"survey-nov-10-2025"

  let rowStyle = {
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
            }


const steps_1 = [

   {
      id: "role",
      title: "Role",
      fields: ["role", "roleDetail"],
      content: (
        <>
          <Form.Item
            label="1. What best describes you?"
            name="role"
            rules={[{ required: true, message: "Please select your role" }]}
          >
            <Radio.Group>
              <Radio value="creator">Creator</Radio>
              <Radio value="coach">Coach (Fitness, Career)</Radio>
              <Radio value="shopify">Shopify Store</Radio>
              <Radio value="business">Business</Radio>
              <Radio value="agency">Agency</Radio>
              <Radio value="startup">Startup</Radio>
              <Radio value="other">Other</Radio>
            </Radio.Group>
          </Form.Item>

          {/* show roleDetail if shopify or other */}
          <Form.Item shouldUpdate noStyle>
            {() =>
              form.getFieldValue("role") && (
                <Form.Item
                  label="Please describe your niche and website link"
                  name="roleDetail"
                  rules={[{ required: true, message: "This field is required" }]}
                >
                  <Input.TextArea
                    placeholder={`Please share more details about what you do as ${form.getFieldValue(
                      "role"
                    ) || ""} and your website link`}
                    rows={2}
                  />
                </Form.Item>
              )
            }
          </Form.Item>
        </>
      ),
    },

    {
      id: "automation",
      title: "Automation",
      fields: ["automationType", "automationDetail"],
      content: (
        <>
          <Form.Item
            label="2. What type of automation are you using?"
            name="automationType"
            rules={[{ required: true, message: "Please select one" }]}
          >
            <Radio.Group>
              <Radio value="quick">Quick Automations</Radio>
              <Radio value="flow">Flow Automations</Radio>
              <Radio value="both">Both</Radio>
            </Radio.Group>
          </Form.Item>
{/* 
          <Form.Item
            label="Please describe your niche / detailed input (brief)"
            name="automationDetail"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input.TextArea rows={2} />
          </Form.Item> */}
        </>
      ),
    },

    {
      id: "quickGaps",
      title: "Quick Gaps",
      fields: ["quickGaps", "quickOther"],
      showIf: (values) =>
        values.automationType === "quick" || values.automationType === "both",
      content: (
        <>
          <Form.Item
            label="3. What is missing in Quick Automations?"
            name="quickGaps"
            rules={[{ required: true, message: "Select at least one" }]}
          >
            <Checkbox.Group style={rowStyle}>
              <Checkbox value="followup">Follow-up Message</Checkbox>
              <Checkbox value="rerun">Re-run Automation</Checkbox>
              <Checkbox value="tag">Tag Contacts</Checkbox>
              <Checkbox value="collect">Collect Email / WhatsApp</Checkbox>
              <Checkbox value="other">Other</Checkbox>
            </Checkbox.Group>
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {() =>
              Array.isArray(form.getFieldValue("quickGaps")) &&
              form.getFieldValue("quickGaps").includes("other") && (
                <Form.Item
                  label="Please specify (Quick Automations)"
                  name="quickOther"
                  rules={[{ required: true, message: "Please provide details" }]}
                >
                  <Input.TextArea rows={2} />
                </Form.Item>
              )
            }
          </Form.Item>
        </>
      ),
    },

    {
      id: "flowGaps",
      title: "Flow Gaps",
      fields: ["flowGaps", "flowOther"],
      showIf: (values) =>
        values.automationType === "flow" || values.automationType === "both",
      content: (
        <>
          <Form.Item
            label="4. What is missing in Flow Automations?"
            name="flowGaps"
            rules={[{ required: true, message: "Select at least one" }]}
          >
            <Checkbox.Group style={rowStyle}>
              <Checkbox value="templates">Templates</Checkbox>
              <Checkbox value="tagging">Custom Tagging Contacts</Checkbox>
              <Checkbox value="crm">CRM Support</Checkbox>
              <Checkbox value="integration">Integration</Checkbox>
              <Checkbox value="dashboard">Dashboard</Checkbox>
              <Checkbox value="other">Other</Checkbox>
            </Checkbox.Group>
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {() =>
              Array.isArray(form.getFieldValue("flowGaps")) &&
              form.getFieldValue("flowGaps").includes("other") && (
                <Form.Item
                  label="Please specify (Flow Automations)"
                  name="flowOther"
                  rules={[{ required: true, message: "Please provide details" }]}
                >
                  <Input.TextArea rows={2} />
                </Form.Item>
              )
            }
          </Form.Item>
        </>
      ),
    },

    {
      id: "alternative",
      title: "Alternative",
      fields: ["alternative", "alternativeOther"],
      content: (
        <>
          <Form.Item
            label="5. If you weren’t using InstantDM, what would you use instead?"
            name="alternative"
            rules={[{ required: true, message: "Please choose one" }]}
          >
            <Radio.Group>
              <Radio value="manychat">Manychat</Radio>
              <Radio value="linkdm">LinkDM</Radio>
              <Radio value="inro">Inro</Radio>
              <Radio value="zorcha">Zorcha</Radio>
              <Radio value="other">Other</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {() =>
              form.getFieldValue("alternative") === "other" && (
                <Form.Item
                  label="Please specify alternative"
                  name="alternativeOther"
                  rules={[{ required: true, message: "Please provide details" }]}
                >
                  <Input />
                </Form.Item>
              )
            }
          </Form.Item>
        </>
      ),
    },

    {
      id: "goal",
      title: "Goal",
      fields: ["goal"],
      content: (
        <Form.Item
          label="6. What’s your #1 goal with InstantDM?"
          name="goal"
          rules={[{ required: true, message: "Please enter your goal" }]}
        >
          <Input.TextArea rows={3} placeholder="I use instantDM to increase my sales call bookings." />
        </Form.Item>
      ),
    },

    {
      id: "rating",
      title: "Rating",
      fields: ["rating"],
      content: (
        <Form.Item
          label="7. How would you rate InstantDM?"
          name="rating"
          rules={[{ required: true, message: "Please rate us" }]}
        >
          <Rate />
        </Form.Item>
      ),
    },

    {
      id: "featureRequest",
      title: "Feature",
      fields: ["featureRequest", "featureOther"],
      content: (
        <>
          <Form.Item
            label="8. What feature are you waiting for?"
            name="featureRequest"
            rules={[{ required: true, message: "Please select at least one" }]}
          >
            <Checkbox.Group style={rowStyle}>
              <Checkbox value="app">Android / iOS App</Checkbox>
              <Checkbox value="integrations">Integrations</Checkbox>
              <Checkbox value="rerun">Re-Run Automation</Checkbox>
              <Checkbox value="linkbio">Link In Bio</Checkbox>
              <Checkbox value="payments">Collect Payments</Checkbox>
              <Checkbox value="other">Other</Checkbox>
            </Checkbox.Group>
          </Form.Item>

          <Form.Item shouldUpdate noStyle>
            {() =>
              Array.isArray(form.getFieldValue("featureRequest")) &&
              form.getFieldValue("featureRequest").includes("other") && (
                <Form.Item
                  label="Please specify feature"
                  name="featureOther"
                  rules={[{ required: true, message: "Please provide details" }]}
                >
                  <Input.TextArea rows={2} />
                </Form.Item>
              )
            }
          </Form.Item>
        </>
      ),
    },

    {
      id: "bug",
      title: "Bug",
      fields: ["bug"],
      content: (
        <Form.Item
          label="9. What bug should we fix immediately?"
          name="bug"
          rules={[{ required: true, message: "Please describe a bug" }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>
      ),
    },

    {
      id: "problem",
      title: "Problem",
      fields: ["problem"],
      content: (
        <Form.Item
          label="10. What’s the biggest problem you want InstantDM to solve?"
          name="problem"
          rules={[{ required: true, message: "Please describe" }]}
        >
          <Input.TextArea rows={3} />
        </Form.Item>
      ),
    },

];

const sub_font_style = {
fontWeight: 400 ,
fontSize:"12px"
}
const main_font_style = {
fontWeight: "bold" ,
fontSize:"14px"
}
const steps = [

{
  id: "nextIssue",
  title: "Immediate Issue",
  fields: ["issueType", "issueOther"],
  content: (
    <>
      <Form.Item
        label="What issue do we need to fix immediately?"
        name="issueType"
        rules={[{ required: true, message: "Please select at least one" }]}
      >
        <Checkbox.Group style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Checkbox value="nextPostAutomation">
            Next Post Automation not working properly
          </Checkbox>
          <Checkbox value="flowAutomation">
            Flow Automation not triggering properly
          </Checkbox>
          <Checkbox value="shopify">
            Shopify Automation not triggering properly
          </Checkbox>
          <Checkbox value="ui">
            UI is not looking good
          </Checkbox>
          <Checkbox value="noIssue">
            No issue, everything is fine
          </Checkbox>
          <Checkbox value="other">Other</Checkbox>
        </Checkbox.Group>
      </Form.Item>

      <Form.Item shouldUpdate noStyle>
        {() =>
          Array.isArray(form.getFieldValue("issueType")) &&
          form.getFieldValue("issueType").includes("other") && (
            <Form.Item
              label="Please specify the issue"
              name="issueOther"
              rules={[{ required: true, message: "Please provide details" }]}
            >
              <Input.TextArea rows={2} placeholder="Describe the issue briefly..." />
            </Form.Item>
          )
        }
      </Form.Item>
    </>
  ),
},

{
  id: "nextFeature",
  title: "Next Feature",
  fields: ["featureRequest", "featureOther", "aiUseCase"],
  content: (
    <>
      <Form.Item
        label="What feature do we need to build next?"
        name="featureRequest"
        rules={[{ required: true, message: "Please select at least one" }]}
      >
        <Checkbox.Group style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Checkbox value="googleSheets">Integration with Google Sheets</Checkbox>
          <Checkbox value="teamAccess">Team Access</Checkbox>
          <Checkbox value="teamAccess">Collab Posts - Access Collab posts from creators you collabed with.</Checkbox>

          <Checkbox value="contentScheduling">Content Scheduling - Post directly from instantDM</Checkbox>
          <Checkbox value="aiAgent">AI Agent for DM Automation</Checkbox>
          <Checkbox value="other">Other</Checkbox>
        </Checkbox.Group>
      </Form.Item>

      {/* Text area for "Other" feature */}
      <Form.Item shouldUpdate noStyle>
        {() =>
          Array.isArray(form.getFieldValue("featureRequest")) &&
          form.getFieldValue("featureRequest").includes("other") && (
            <Form.Item
              label="Please specify the feature"
              name="featureOther"
              rules={[{ required: true, message: "Please provide details" }]}
            >
              <Input.TextArea rows={2} placeholder="Describe the feature you’d like us to add..." />
            </Form.Item>
          )
        }
      </Form.Item>

      {/* Use case field for AI Agent */}
      <Form.Item shouldUpdate noStyle>
        {() =>
          Array.isArray(form.getFieldValue("featureRequest")) &&
          form.getFieldValue("featureRequest").includes("aiAgent") && (
            <Form.Item
              label="AI Agent Use Case"
              name="aiUseCase"
              rules={[{ required: true, message: "Please describe your AI agent use case" }]}
            >
              <Input.TextArea rows={2} placeholder="Example: Automatically reply to DMs about product pricing..." />
            </Form.Item>
          )
        }
      </Form.Item>
    </>
  ),
},


];


  useEffect(() => {

    checkSurvey();
        async function checkSurvey() {
      if (!userData?.user_id) return;

      const docRef = doc(fireDB, survery_collection, userData?.user_id);
      const docSnap = await getDoc(docRef);
      if(PlanData?.plan_credits != "unlimited"){
        console.log("No creidts =====")
        return
        }
      console.log("-==-=-=-=-= snap exists" ,docSnap.exists() )
      // return
      if (docSnap.exists()) {
        const data = docSnap.data();
        // if(PlanData?.plan_credits != "unlimited"){
        // return

        // }

        // Case 1: Completed → never show
        if (data.completed) {
          setOpen(false);
          return;
        }

        // Case 2: Remind until still active
        if (data.remindUntil && data.remindUntil.toDate() > new Date()) {
          setOpen(false);
          return;
        }

        // Case 3: Exists but remind expired → show
        setOpen(true);
      } else {
        // Case 4: No survey doc → show
        setOpen(true);
      }
    }

    checkSurvey();
  }, [userData?.user_id]);
  

  const handleSurveySubmit = async () => {
    const values = form.getFieldsValue(true)
    const docRef = doc(fireDB, survery_collection, userData?.user_id);
    await setDoc(docRef, {
      completed: true,
      answers: values,
      timestamp: new Date()
    });
    setOpen(false);
    setThankYou(true);
  };

    const handleRemindLater = async () => {
    const remindHours = 1; // or 5 hours
    const remindUntil = new Date(Date.now() + remindHours * 60 * 60 * 1000);

    const docRef = doc(fireDB, survery_collection, userData?.user_id);
    await setDoc(
      docRef,
      {
        completed: false,
        remindUntil,
        timestamp: serverTimestamp()
      },
      { merge: true } // keep existing answers if any
    );

    setOpen(false);
  };

    const next = async () => {
    try {
      const step = steps[current];
      if (step.fields) {
        await form.validateFields(step.fields);
      }
      setCurrent((c) => c + 1);
    } catch (err) {
      console.log("Validation failed:", err);
    }
  };

  const prev = () => setCurrent((c) => c - 1);

  // console.log("Modal open")

  return (
    <div>
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      width={600}
      title="InstantDM Survey"
    >
   {current === -1 ? (
    // 👋 Welcome / Intro screen
    <div style={{ padding: "24px", textAlign: "center" }}>
      <h2 style={{ marginBottom: 12 }}>We’d love your feedback 💬</h2>
      <p style={{ marginBottom: 24 }}>
        Please take 2 minutes to complete this short survey and help us improve InstantDM.
      </p>
      <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
       
        <Button onClick={handleRemindLater}>Remind Me Later</Button>
         <Button type="primary" onClick={() => setCurrent(0)}>
          Start Survey
        </Button>
      </div>
    </div>
  ) : (

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSurveySubmit}
        preserve={true}
      >
        <div style={{ marginTop: 24 }}>{steps[current].content}</div>

        <div style={{ marginTop: 24, textAlign: "right" }}>
          {current > 0 && (
            <Button style={{ marginRight: 8 }} onClick={() => {
              setCurrent(current -1)
            }}>
              Previous
            </Button>
          )}
          {current < steps.length - 1 && (
            <Button type="primary" onClick={next}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          )}
        </div>
      </Form>
  ) }
    </Modal>
    <Modal
  open={thankYou}
  footer={null}
  centered
  closable={false}
  title="Thank you 🎉"
>
  <p>We appreciate your feedback! Would you like to share your thoughts publicly? Here are a few things you could rate us on:</p>

 <ul style={{ textAlign: "left", marginBottom: 20, paddingLeft: 20 }}>
    <li>✨ Ease of use — was InstantDM simple to get started with?</li>
    <li>⚡ Features — do the automations cover your needs?</li>
    <li>💬 Support — did you feel supported along the way?</li>
    <li>💰 Value for money — do you feel InstantDM is worth the price?</li>
    <li>🌟 Overall experience — your honest impression</li>
  </ul>
  <Button
    type="primary"
    block
    onClick={() =>
      window.open(
        "https://www.trustpilot.com/review/instantdm.com"
      )
    }
  >
    Rate us on Trustpilot
  </Button>
   <Button
    color="primary"
    variant="outline"
    block
    onClick={() => setThankYou(false)}
  >
    Close
  </Button>
</Modal>
    </div>
  );
}


function HomeV2() {

  const [searchParams] = useSearchParams();
  let  default_tab = searchParams.get("tab"); 
  default_tab = default_tab || "1"

  const navigate = useNavigate();
  const [loading, setLoading] = useState()
  const [data, setData] = useState()
  const { Meta } = Card;
  const [loadingAutomated, setLoadingAutomated] = useState()
  const [dataAutomated, setDataAutomated] = useState({ data: undefined })

  const [dataAutomatedFormated, setDataAutomatedFormated] = useState({})
  const [loadMore, setLoadMore] = useState(false)

  const [oldData, setOldData] = useState([])
  const [messageApi, contextHolder] = message.useMessage();

  const [postsError, setPostsError] = useState(undefined)

  const [totalCredits, setTotalCredits] = useState()

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  const [userUsage, setUserUsage] = useState({ "monthly_count": "" })
  const [accountViral, setAccountViral] = useState({})
  const [loadingUserUsage, setLoadingUserUsage] = useState(true)

  const [selectedCategory, setSelectedCategory] = useState('posts')

  const [showPlanModal, setShowPlanModal] = useState(false)

  const [statusError, setStatusError] = useState(false)

  const [trailActive, setTrailActive] = useState(8)

  const [filterPosts, setFilterPosts] = useState("all")

  
    const [postsLimitReached, setPostsLimitReached] = useState()
    const [postsAutomationLimit, setPostsAutomationLimit] = useState("Unlimitied")
  
  
    const [allowMoreAutomation, setAllowMoreAutomation] = useState(true)
  
    const [nextPostsLimitReached, setNextPostsLimitReached] = useState()
    const [nextPostsAutomationLimit, setNextPostsAutomationLimit] = useState(
        AccessOrNot(
          "next_post_automation",
          true,
          0,
          true)?.limit || "Unlimited"
      )
  
      useEffect(() => {
        if(nextPostsAutomationLimit == "Unlimited"){
          setNextPostsAutomationLimit(100)
          return
        }
  
      },[nextPostsAutomationLimit])
  
      useEffect(() => {
      if(data?.posts_lists?.data){
        setNextPostsLimitReached(data?.posts_lists?.data?.length)
        
      }
  
    },[data])
    
    
  
    useEffect(() => {
      console.log("-=-=-=-=-postsLimitReached" , postsLimitReached , postsAutomationLimit)
      if( postsLimitReached == undefined || postsAutomationLimit == "Unlimited"){
        return
      }
      if (postsLimitReached >= postsAutomationLimit) {
        setAllowMoreAutomation(false)
        messageApi.open({
          type: 'error',
          content: `You have reached your monthly limit of ${postsAutomationLimit} automations. Please upgrade your plan to continue.`,
          duration: 15,
          key: 3
        })
      }
  
    },[postsLimitReached])
  
    useEffect(() => {
  
      setPostsLimitReached(Object.values(dataAutomatedFormated).filter(v => v === true).length)
  
    },[dataAutomatedFormated])
  

  useEffect(() => {

    if(!filterPosts || filterPosts == "all"){
      return 
    }

  },[filterPosts])

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token == undefined) {

      navigate("/signup")
    }
    
    setLoadMore(true)
  }, [])

  useEffect(() => {
    if (postsError != undefined) {
      messageApi.open({
        type: 'error',
        content: postsError,
        duration: 15,
        key: 2
      })
    }
  }, [postsError])

  useEffect(() => {


    if (loadingUserUsage == true) {
      return
    }

    setAccountViral({ "reason_notify": userUsage?.automation_setting?.reason_notify || {}})
    setUserUsage({ "monthly_count": userUsage?.data?.monthly_count })

  }, [loadingUserUsage])

  const [userPlan, setUserPlan] = useState()
  const [userPlanLoading, setUserPlanLoading] = useState(true)

  useEffect(() => {

    let tempData = {}
    if (dataAutomated["data"] == undefined) {
      return
    }

    dataAutomated["data"].map((item) => {
      if(item?.flow_editor == true){
        tempData[item.post_id] = "flow_editor"
      }
      else{
        tempData[item.post_id] = item.automated_segment.length > 0 ? true : false
      }
      
    })

    setDataAutomatedFormated(tempData)
    let apiURL = `ig-usage-stat?tz=${user_tz}`
    callAPI({ url: apiURL, method: "GET", loadingState: setLoadingUserUsage, dataState: setUserUsage })

    let apiURL2 = `user_plan`
    callAPI({ url: apiURL2, method: "GET", loadingState: setUserPlanLoading, dataState: setUserPlan })



  }, [dataAutomated])


  useEffect(() => {

    if (userPlan == undefined) {
      return
    }
    if (userPlan?.data == undefined) {
      return
    }
    if (userPlan?.data != undefined) {
      let copy_data = { ...userPlan }

      let credit = Number(copy_data?.data?.plan_credits) + Number(copy_data?.data?.topup_credit)

      setTotalCredits(credit)


      let temp_plan_id = "428337"

    const date1Obj = new Date(userPlan.data.account_created);

    const date2Obj = new Date();
    
    const differenceInTime = date2Obj.getTime() - date1Obj.getTime();
    let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
    
    let current_plan_id = userPlan.data.plan_details.id


    
    if(differenceInDays < 8){
      
      localStorage.setItem("og_planID",current_plan_id )
      current_plan_id = current_plan_id == "free" ? temp_plan_id : current_plan_id
      
      setTrailActive(3)
      
    }
    localStorage.setItem("planid",current_plan_id )

    let posts_automation = AccessOrNot(
        "posts_automation",
        true,
        0,
        true)?.limit || "Unlimited"
    console.log("-=-=-=-=-=-posts_automation" , posts_automation)
    setPostsAutomationLimit(posts_automation);
    
    localStorage.setItem("founding_user", userPlan.data.founding_user)
      setUserPlan({ ...userPlan.data })

      return
    }

  }, [userPlan])

  useEffect(() => {
    messageApi.destroy(1)

    if (data != undefined && oldData.length < 1) {
      // On every inital load
      if (data.fb_api != undefined) { localStorage.setItem("fb_api", data.fb_api) }
      if (data.ig_api != undefined) { localStorage.setItem("ig_api", data.ig_api) }
    }

    if (oldData.length < 1 || data == undefined) {
      return
    }

    if (data?.code != 200) {
      setStatusError(true)
      return
    }
    if (data?.code == 200) {
      setStatusError(false)
    }

    let oldDataTemp = [...oldData]
    setOldData([])

    // console.log("=====DATATATA=====", data)
    if (data?.posts_lists?.error != undefined) {
      setPostsError(data.posts_lists.error.message)
    }

    if (data.posts_lists.data != undefined) {

      setData({ ...data, posts_lists: { ...data.posts_lists, data: [...oldDataTemp, ...data.posts_lists.data] } })
    }



    setStatusError(false)


  }, [data])

  useEffect(() => {
    if (loading == true) {
      return
    }
    if (loadMore == false) {
      return
    }
    // messageApi.open({
    //   type: 'loading',
    //   content: 'Loading your posts',
    //   duration: 0,
    //   key: 1
    // });

    let apiURL = ""

    if (selectedCategory == "posts") {
      apiURL = "ig-posts"
    }
    if (selectedCategory == "stories") {
      apiURL = "ig-stories"
    }

    if (selectedCategory == "next-post") {
      apiURL = "next-post"
    }
    // let old_data = []

    // console.log("API going to call")
    if (data?.posts_lists?.paging?.cursors?.after) {
      apiURL += `?after=${data?.posts_lists?.paging?.cursors?.after}`
      if (data.posts_lists.data != undefined) {
        setOldData([...data.posts_lists.data])
      }

    }

    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

    if (dataAutomated.data == undefined) {
      let apiAutmatedURL = `automate-post`
      callAPI({ url: apiAutmatedURL, method: "GET", loadingState: setLoadingAutomated, dataState: setDataAutomated })
    }


    setLoadMore(false)


  }, [loadMore])

  useEffect(() => {

    setData()
    setLoadMore(loadMore == undefined ? true : undefined)


  }, [selectedCategory])


  const [paymentLinkData, setPaymentLinkData] = useState()
  const [paymentLinkLoading, setPaymentLinkLoading] = useState()

  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

  const [showWaitingPaymentUpdate, setShowWaitingPaymentUpdate] = useState(false)
  const [showWaitingPaymentFailed, setShowWaitingPaymentFailed] = useState(false)

  const [showWhatsNew, setShowWhatsNew] = useState(false)

  let release_id = "release_30122024"

  useEffect(() => {


    if (paymentLinkData?.open_url) {

      window.location.href = paymentLinkData?.payment_url
      return

    }

    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ", 
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id, // Order ID from your server (generated by your backend)
          handler: function (response) {
              setShowPlanModal(false)
              setShowWaitingPaymentUpdate(true)

              message.success("Payment completed, Please wait while we're verfiying!")
              let user_detail = JSON.parse(localStorage.getItem("userData"))
              let igid = localStorage.getItem("ig_id")

              const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
              const CHAT_ID = '776956029';
              const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
              let tele_message = `[SUBSCRIBED PLAN] - user ${user_detail.emailid}  - Subscribed for  , IG ID = ${igid} , user id = ${user_detail.user_id}`
              let data = {
                  chat_id: CHAT_ID,
                  text: tele_message
              };


            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Message sent successfully:', data);
                })
                .catch(error => {
                    console.error('Error sending message:', error);
                });
            setPaymentLinkData({})




          },
          error: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentFailed(true)
            setPaymentLinkData({})
            // alert("Payment Failed: " + response.error.description);
          },
          prefill: {
            name: paymentLinkData.customer_name,
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
          display: {
            handler: function () {
              return {
                "offers": [
                  {
                    "type": "discount",
                    "description": "10% discount on first purchase",
                    "amount": 100
                  },
                  {
                    "type": "coupon",
                    "description": "Rs. 100 off on total bill",
                    "code": "INSTANT10"
                  }
                ]
              }
            }
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  function planContent() {

    if (userPlan == undefined) {
      return <p>Loading</p>
    }
    return (
      <div>

        <Statistic
          title="Plan credits"
          value={userPlan?.plan_credits}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        <Statistic
          title="Topup credits"
          value={userPlan?.topup_credit}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        {userPlan?.plan_details?.id == "free" && <Button type="primary" style={{ marginTop: '10px' }} onClick={() => { userPlan?.plan_details?.id == "free" && setShowPlanModal(true) }}>
          Upgrade to paid plan
        </Button>
        }

        {/* <Button type="primary" style={{marginTop:'10px'}} onClick={() => {userPlan?.plan_details?.id == "free" ? setShowPlanModal(true) : createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData) }}>
              { userPlan?.plan_details?.id == "free" ? "Upgrade to paid plan" : "Buy more credits"}
            </Button> */}

      </div>
    )
  }
const [previewImage, setPreviewImage] = useState(null);
const [previewOpen, setPreviewOpen] = useState(false);


    const UsageCard = ({
        title,
        description,
        buttonText = "Learn More",
        onClick,
        images = [],
        features = [],
        link,
        ignoreText,
      }) => {
        return (
          <div
            style={{
              marginRight: "10px",
              display: "flex",
              flexDirection: "column",
              // maxWidth:"400px",
              // minWidth: "60%",
              
            }}
            className="usage-content white-bg-border reuse-usage"
          >
            <Flex
              align="center"
              justify="space-between"
              wrap
              style={{ marginBottom: "10px", width: "100%" }}
            >
              <h3 style={{ margin: 0, flex: 1, fontWeight: "500" }}>{title}</h3>
              {/* <Button className="desktop" onClick={onClick} color="purple" variant="solid">
                {buttonText}
              </Button> */}
            </Flex>

            <p>{description}</p>

            {/* Image Carousel */}
            {images.length > 0 && (
              <Carousel autoplay dots className="usage-carousel" style={{ marginTop: 16 }}>
                {images.map((img, index) => (
                  <div key={index}>
                    <img
                      src={img}
                      alt={`slide-${index}`}
                      style={{ width: "100%", height: "200px", objectFit: "cover", borderRadius: "12px" }}
                    />
                  </div>
                ))}
              </Carousel>
            )}

            {/* Feature List */}
            {features.length > 0 && (
              <List
                size="small"
                style={{ marginTop: 16 }}
                dataSource={features}
                renderItem={(item) => (
                  <List.Item style={{ paddingLeft: 0 }}>
                    <span>✅</span>
                    <span style={{ marginLeft: 8 }}>{item}</span>
                  </List.Item>
                )}
              />
            )}

            {/* Mobile Button */}
            { !link ? <Button
              // className="mobile"
              onClick={onClick}
              color="purple"
              variant="solid"
              style={{ marginTop: 16 }}
            >
              {buttonText}
            </Button> : <Button
              // className="mobile"
              href={`${link}`}
              color="purple"
              variant="solid"
              style={{ marginTop: 16 }}
            >
              {buttonText}
            </Button> }
            
            {
              ignoreText && <p style={{fontSize:"12px" , opacity:".5", textAlign:"center"}}>{ignoreText}</p>
            }

          </div>
        );
      };
    
  // console.log("========CREDIT=====" , totalCredits)
  return (
    <div className="page-layout">
      {contextHolder}

      <Sider />
      <div className="page-content">
            {(userPlan?.sub_status != undefined && userPlan?.sub_status != "active" && userPlan?.plan_details?.id != "free") && <Alert
              message="Subscription Expired"
              description="Ohho no, you're supscription expired, please renew to continue"
              type="error"
              style={{ marginBottom: '10px', marginTop: '10px' }}
              action={
                <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                  Renew Subscription
                </Button>
              }
              showIcon />
            }
            {( trailActive < 8 && userPlan?.plan_details?.id == "free") && <Alert
              message="7 Days Free Trail"
              description={`You're currently on 7 days free trail, and your free trail will exipre in ${7 - trailActive} days.`}
              
              style={{ marginBottom: '10px', marginTop: '10px' }}
              action={
                <div className="free-alert-btns">
                <Button style={{marginRight:"10px"}} size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                  Extend Free Trail
                </Button>

                <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                  Show Plans
                </Button>
                </div>
              }
              showIcon />
            }
            {( trailActive >=8 && totalCredits != 0 && userPlan?.plan_details?.id == "free") && <Alert
              message="Free Plan"
              description="You're currently on free plan, click here to upgrade your plan."
              type="error"
              style={{ marginBottom: '10px', marginTop: '10px' }}
              action={
                <div className="free-alert-btns">
                <Button style={{marginRight:"10px"}} size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                  Extend Free Trail
                </Button>

                <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                  Show Plans
                </Button>
                </div>
              }
              showIcon />
            }
            {(totalCredits < 1 && userPlan?.plan_details?.id == "free") && <Alert
              message="Automation Stoped!"
              description="You have reached your monthly free usage limit. To continue using our automation services, please consider upgrading to a paid plan."
              type="error"
              style={{ marginBottom: '10px', marginTop: '10px' }}
              action={
                <div className="free-alert-btns">
                <Button style={{marginRight:"10px"}} target="_blank" size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                  Extend Free Trail
                </Button>

                <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                  Show Plans
                </Button>
                </div>
              }
              showIcon />
            }
            {(totalCredits < 1 && userPlan?.plan_details?.id != "free") && <Alert
                message="Credits Over, Automation Stoped!"
                description="Switch to different plan to continue.."
                type="error"
                style={{ marginBottom: '10px', marginTop: '10px' }}
                action={
                  <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                    Show Plans
                  </Button>
                }
                showIcon />
              }
        <div className="home-sec-1" style={{height:"100vh", overflowY:"scroll"}}>

          <Flex wrap="nowrap" style={{overflowX:"scroll" , overflowY:"scroll"}}>
            {
            (accountViral?.reason_notify?.title != undefined && !accountViral?.reason_notify?.title.includes("Message from Instagram")) &&
            <UsageCard title={accountViral?.reason_notify?.title} description={accountViral?.reason_notify?.message} /> }

            
            <div className="col-desktop-row-mobile" vertical>
            {/* <UsageCard title={"InstantDM is Public, Suggest Features."} description={"✨ Got an idea to make InstantDM better? We’d love to hear it! \n 💡 Submit your feature requests and help shape what we build next."} buttonText="Suggest new feature" link="/shopify" /> */}
            {/* {!localStorage.getItem("shopify_store") && <UsageCard title={"InstantDM ❤️ Shopify "} description={"Boost your sales with automated follow ups, upsells and grow your community for organic sales or just share link with one click. Don’t miss out on sales — connect shopify now to start making more from your Instagram DMs."} buttonText="Watch Video" link="/shopify" />} */}

            {/* {!localStorage.getItem("shopify_store") && <UsageCard title={"🔥 Sell online with zero platform fee"} description={"Sell anything and everything online using Instant Mini with zero platform and fast withdrwal! 🙌"} buttonText="Open Mini" link="/digital-products" />} */}
            {/* <UsageCard title={"❤️ Love InstantDM"} description={"Share your feedback. 🌟 Help others discover InstantDM by leaving a quick review on G2. Your support means the world to us! 🙌"} buttonText="Submit Feedback" link="https://www.g2.com/products/instantdm/reviews" /> */}
            {/* <UsageCard title={"🤑 Earn with InstantDM"} description={"Earn referral commission of upto 50% for every refferal with your coupon code. Get your link, Make videos, Earn money🙌"} buttonText="Know More" link="/referral-dashboard" /> */}
            <UsageCard title={"✨ FB Automation is Live"} description={"Facebook Automation is live now, you can start automating facebook along with your instagram posts/reels."} buttonText="Automate FB" link="/fb"/>
            
            </div>
          
         {postsAutomationLimit !="Unlimited" &&  
         <div className="usage-content desktop white-bg-border" style={{display:"flex", flexDirection:"column", marginRight:"10px", width:"80%", maxWidth:"400px"}}>

        {postsAutomationLimit !="Unlimited" && <Col style={{marginTop:"-10px", width:"350px", overflowX:"scroll"}} className="hide-scrollbar">

        <Flex align="center" justify="space-between" wrap style={{marginBottom:"10px",width:"100%"}}>
        <h3 style={{flex:1, opacity:".5", fontWeight:"500"}}>Posts Automated</h3>
        <Button onClick={() => setShowPlanModal(true)} color="purple" variant="solid">Upgrade Plan</Button>
        </Flex>
          <Progress
              percent={
                (
                  postsLimitReached /
                    postsAutomationLimit *
                  100
                ) || 0
              }
              steps={
                postsAutomationLimit
              }
              strokeColor={
                (() => {
                  
                  const percent = (postsLimitReached / postsAutomationLimit) * 100;
                  if (percent >= 100) return "#ff4d4f"; // red
                  if (percent >= 60) return "#faad14"; // orange
                  return "#4f8cff"; // blue
                })()
              }
              format={() => {
                
                const left = Math.max(postsAutomationLimit - postsLimitReached, 0);
                const percent = (postsLimitReached / postsAutomationLimit) * 100;
                let color = "#4f8cff";
                if (percent >= 100) color = "#ff4d4f";
                else if (percent >= 60) color = "#faad14";
                return (
                  <span style={{ color, fontWeight: 600 }}>
                    {left} remaining
                  </span>
                );
              }}
            />

      </Col>}
          

          </div>  }

          {postsAutomationLimit !="Unlimited" && <div className="usage-content mobile white-bg-border" style={{display:"flex", flexDirection:"column", marginRight:"10px", width:"80%", maxWidth:"400px"}}>
          
          {/* <Col>

          <Statistic
            title="Monthly Automated"
            value={userUsage.monthly_count || "NA"}
            // precision={2}
            valueStyle={{
              color: 'black',
              fontWeight: '600'
            }} />

          </Col>
          
          <Col>
          <Statistic title="Available credits" value={userPlan?.plan_credits != "unlimited" ? totalCredits : userPlan?.plan_credits} />
          </Col>
           */}

        {postsAutomationLimit !="Unlimited" && <Col style={{marginTop:"-10px", width:"350px", overflowX:"scroll"}} className="hide-scrollbar">

        <Flex align="center" justify="space-between" wrap style={{marginBottom:"10px",width:"100%"}}>
        <h3 style={{flex:1, opacity:".5", fontWeight:"500"}}>Posts Automated</h3>
        <Button onClick={() => setShowPlanModal(true)} color="purple" variant="solid">Upgrade Plan</Button>
        </Flex>
          <Progress
              percent={
                (
                  postsLimitReached /
                    postsAutomationLimit *
                  100
                ) || 0
              }
              steps={
                postsAutomationLimit
              }
              strokeColor={
                (() => {
                  
                  const percent = (postsLimitReached / postsAutomationLimit) * 100;
                  if (percent >= 100) return "#ff4d4f"; // red
                  if (percent >= 60) return "#faad14"; // orange
                  return "#4f8cff"; // blue
                })()
              }
              format={() => {
                
                const left = Math.max(postsAutomationLimit - postsLimitReached, 0);
                const percent = (postsLimitReached / postsAutomationLimit) * 100;
                let color = "#4f8cff";
                if (percent >= 100) color = "#ff4d4f";
                else if (percent >= 60) color = "#faad14";
                return (
                  <span style={{ color, fontWeight: 600 }}>
                    {left} remaining
                  </span>
                );
              }}
            />
        {/* <Progress  type="circle" percent={ (AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.current_usage / AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.limit) *100 } format={ percent => `${AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.current_usage} / ${AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.limit}`} /> */}

      </Col>}
          

          </div>}

          </Flex>

          <Flex direction="column" gap="middle" justify="space-between" >
          
          <Tabs defaultActiveKey={default_tab} style={{width:"100%",}} items={[

            {
              "key": "1",
              "label": "Quick Automation",
              children: <IGPosts nextPostsAutomationLimit={nextPostsAutomationLimit} allowMoreAutomation={allowMoreAutomation}  setShowPlanModal={setShowPlanModal} />
            },
           
            {
              "key":"3",
              "label":<p>DM & Flow Automation</p>,
              "children": <AutomationList /> 
            },
            
          ]} />
          {/* <WhatsNew/> */}

          </Flex>



        </div>

      </div>

      
      <a className="mobile" target="_blank" href="https://instagram.com/instant.dm">
      <FloatButton style={{ padding:"0px",bottom:"100px"}} icon={<MessageOutlined />} >
      </FloatButton>
      </a>

      <a className="desktop" target="_blank" href="https://instagram.com/instant.dm">
      <FloatButton style={{  padding:"0px", bottom:"50px"}} icon={<MessageOutlined  />} >
      </FloatButton>
      </a>


      <Modal
        title="Plans"
        open={showPlanModal}
        onCancel={() => setShowPlanModal(false)}
        width='100%'
        // maxWidth='800px'
      >


        <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
      </Modal>

        
        { userPlan?.plan_credits && <WelcomePopup PlanData={userPlan} /> }


    </div>
  )

}
export default HomeV2;
